export const getAPICredentials = () => {
    const { VUE_APP_STRIPE_KEY,
            VUE_APP_STRIPE_SECRET } = process.env

    return {
        appKey: VUE_APP_STRIPE_KEY,
        appSecret: VUE_APP_STRIPE_SECRET
    }
}

export const createStripeInstance = () => {
    const { appKey } = getAPICredentials()
    return Stripe(appKey)
}

export const elementStyles = () => {
    return {
        base: {
            color: '#00b661',
            fontWeight: 500,
            fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
            fontSize: '20px',
            fontSmoothing: 'antialiased',

            ':focus': {
                color: '#717171',
            },

            '::placeholder': {
                color: '#cfd7df',
            },

            ':focus::placeholder': {
                color: '#717171',
            },
        }
    }
}

export default {
    createStripeInstance,
    elementStyles
}
